<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="tit text-center">
      <p>Qual é o endereço da sua empresa?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-10 col-xl-10">     
        <form @submit="onSubmit">
          <div class="form-row">
            <div class="form-group col-12 col-md-4">
              <label for="cep">CEP</label>
              <input type="text" class="form-control form-control-lg" pattern="\d{5}-?\d{3}" v-model="cep" v-mask="'zipcode'" placeholder="CEP" @change="aoMudarCep" v-focus required>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12 col-md-6">
              <label for="logradouro">Endereço</label>
              <input type="text" class="form-control form-control-lg" v-model="logradouro" placeholder="Logradouro" :disabled="estaBuscandoEndereco">
            </div>
            <div class="form-group col-12 col-md-2">
              <label for="inputPassword4">Número</label>
              <input type="text" class="form-control form-control-lg" v-model="numero" pattern="\d+" title="Números apenas" v-mask="'integer'" placeholder="Nº" :disabled="estaBuscandoEndereco" required>
            </div>
            <div class="form-group col-12 col-md-4">
              <label for="complemento">Complemento</label>
              <input type="text" class="form-control form-control-lg" v-model="complemento" placeholder="Complemento" :disabled="estaBuscandoEndereco">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12 col-md-4">
              <label for="bairro">Bairro</label>
              <input type="text" class="form-control form-control-lg" v-model="bairro" placeholder="Bairro" :disabled="estaBuscandoEndereco"/>
            </div>
            <div class="form-group col-12 col-md-4">
              <label for="estado">Estado</label>
              <at-select v-model="uf" filterable size="large" placeholder="Estado" @on-change="onUfChange" :disabled="estaBuscandoEndereco">
                <at-option v-for="(state, i) in estados" :key="`stateOptions${i}`" :value="state.uf">{{state.nome}}</at-option>
              </at-select>
            </div>
            <div class="form-group col-12 col-md-4">
              <label for="cidade">Cidade</label>
              <at-select v-model="cidade" filterable size="large" :disabled="estaCidadeDesabilitado" placeholder="Cidade">
                <at-option v-for="(city, i) in cidades" :key="`cityOptions${i}`"  :value="city.nome">{{city.nome}}</at-option>
              </at-select>
            </div>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'
import HubConsultaClient from '../../utils/hub-consulta-client'
import StringHelper from '@/utils/string-helper'

export default {
  data() {
    const endereco = this.currentUser.Social.Endereco
    return {
      cep: endereco ? endereco.Cep : null,
      logradouro: endereco ? endereco.Logradouro : null,
      numero: endereco ? endereco.Numero: null,
      complemento: endereco ? endereco.Complemento: null,
      bairro: endereco ? endereco.Bairro: null,
      uf: endereco ? endereco.Uf: null,
      cidade: endereco ? endereco.Cidade: null,
      estaBuscandoEndereco: false,
      estaBuscandoCidades: false,
      estados: [],
      cidades: []
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  computed: {
    estaCidadeDesabilitado: function() { return this.estaBuscandoEndereco || this.cidades.length == 0 },
  },
  methods: {
    aoMudarCep(e) {
      if(Masker.unmaskZipcode(e.target.value).length < 8) return
      this.estaBuscandoEndereco = true
      HubConsultaClient.pegarCeps(e.target.value)
        .then(endereco => {
          this.logradouro = endereco.logradouro
          this.bairro = endereco.bairro
          this.uf = endereco.uf
          this.cidade = endereco.localidade

          this.estaBuscandoEndereco = false
        })
        .catch(() => {
          this.estaBuscandoEndereco = false
        })
    },
    onUfChange() {
      this.cidades = []
      if(!this.uf) {
        this.cidade = ''
        return
      }
      HubConsultaClient.pegarCidades(this.uf)
        .then(cidades => {
          this.cidades = cidades
          if(this.cidade) {
            this.setCity()
          }
        })
    },
    setCity() {
      const city = this.cidades.find(city => {
        return StringHelper.removeAccents(city.nome.toUpperCase()) == StringHelper.removeAccents(this.cidade.toUpperCase())
      })
      if(!city) {
        this.cidade = ''
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = ''
        setTimeout(() => this.cidade = city.nome, 100)
      }
    },
    onSubmit(e) {
      e.preventDefault()
        this.currentUser.Social.Endereco.Cep = Masker.unmaskZipcode(this.cep);
        this.currentUser.Social.Endereco.Logradouro = this.logradouro;
        this.currentUser.Social.Endereco.Numero = this.numero;
        this.currentUser.Social.Endereco.Complemento = this.complemento;
        this.currentUser.Social.Endereco.Bairro = this.bairro;
        this.currentUser.Social.Endereco.Uf = this.uf;
        this.currentUser.Social.Endereco.Cidade = this.cidade;
        
        this.$emit('on-submit', {Social: this.currentUser.Social})
    }
  },
  created() {
    if(!this.currentUser.Social) this.currentUser.Social = {}

    HubConsultaClient.pegarEstados()
    .then(estados => {
      this.estados = estados
      // When the city state is seted before cities is populated the component doesn't show
      // the selected city.
      const uf = this.uf
      const city = this.cidade
      this.uf = ''
      setTimeout(() => {
        this.uf = uf
        this.cidade = city
      }, 100)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/InformacoesPjEnderecoStep.vue